// `'gpu' in navigator` não basta: requestAdapter() devolve null em VM/driver
// antigo/GPU em blocklist, e é async. Memoizado: 1 probe por sessão.
let probe: Promise<boolean> | null = null;

export const isWebGPUAvailable = (): Promise<boolean> => {
  if (probe) { return probe; }

  probe = (async () => {
    const gpu = (navigator as unknown as { gpu?: { requestAdapter(): Promise<unknown | null> } }).gpu;
    if (!gpu) { return false; }

    try {
      return Boolean(await gpu.requestAdapter());
    } catch {
      return false;
    }
  })();

  return probe;
};

export const resetWebGPUProbeForTests = () => { probe = null; };
